import { useState } from 'react';
import { Button, Container, Row, Col, Form } from 'react-bootstrap';
import { RiPhoneLine } from 'react-icons/ri';
import { useDispatch } from 'react-redux';
import { callFromDialer } from '../../../redux/actions/IVR.action';

const Dialpad = () => {
  const dispatch = useDispatch();
  const [number, setNumber] = useState('');
  const [calling, setCalling] = useState(false);

  const handleClick = (value) => {
    setNumber((prev) => prev + value);
  };

  const handleBackspace = () => {
    setNumber((prev) => prev.slice(0, -1));
  };

  const handleClear = () => {
    setNumber('');
  };

  const handleCall = () => {
    if (!number) return;
    setCalling(true);
    dispatch(callFromDialer(number)).finally(() => {
      setCalling(false);
      handleClear();
    });
  };

  return (
    <Container
      className="p-3 text-center"
      style={{
        background: '#ffffff',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.25)',
        borderRadius: '16px',
        border: '1px solid #e8edf3',
        width: '100%',
      }}
    >
      {/* Number Input */}
      <Form.Control
        type="text"
        value={number}
        maxLength={15}
        onChange={(e) => {
          const val = e.target.value;
          if (/^[0-9*#]*$/.test(val)) {
            setNumber(val);
          }
        }}
        placeholder=""
        className="mb-3 text-center"
        style={{
          fontSize: '18px',
          height: '46px',
          borderRadius: '10px',
          border: '1px solid #d0daea',
          background: '#f4f7fb',
          color: '#1a2b4a',
          fontWeight: '600',
          letterSpacing: '0.1em',
        }}
      />

      {/* Digit Buttons */}
      <Row className="g-2 mb-2">
        {['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'].map(
          (digit) => (
            <Col xs={4} key={digit}>
              <Button
                onClick={() => handleClick(digit)}
                className="w-100 py-2"
                style={{
                  borderRadius: '10px',
                  fontSize: '16px',
                  fontWeight: '600',
                  background: '#E6EFF7',
                  border: 'none',
                  color: '#1a2b4a',
                  transition: 'background 0.15s ease',
                }}
                onMouseEnter={(e) => (e.target.style.background = '#d0e0ef')}
                onMouseLeave={(e) => (e.target.style.background = '#E6EFF7')}
              >
                {digit}
              </Button>
            </Col>
          ),
        )}
      </Row>

      {/* Call Button */}
      <Button
        onClick={handleCall}
        disabled={calling || !number}
        className="w-100 mb-2 fw-bold rounded-pill d-flex align-items-center justify-content-center"
        style={{
          height: '44px',
          background: '#F0FFF0',
          border: '1px solid #c3e6cb',
          color: '#1a6b3a',
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        }}
      >
        <RiPhoneLine size={22} />
      </Button>

      {/* Backspace & Clear */}
      <Row className="g-2">
        <Col>
          <Button
            onClick={handleBackspace}
            className="w-100 fw-semibold"
            style={{
              height: '40px',
              borderRadius: '10px',
              background: '#FFE4C4',
              border: '1px solid #f5cba0',
              color: '#7a4010',
            }}
          >
            ⌫
          </Button>
        </Col>
        <Col>
          <Button
            onClick={handleClear}
            className="w-100 fw-semibold"
            style={{
              height: '40px',
              borderRadius: '10px',
              background: '#E6E6FA',
              border: '1px solid #c5c5f0',
              color: '#3a3a8a',
            }}
          >
            Clear
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default Dialpad;